/* Copyright 2013 - 2022 Waiterio LLC */
/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'

const NavBarFiller = () => <div css={{ flexGrow: 1 }} />

export default NavBarFiller
